import { config } from './config';

export async function trackTextFeedback(productLink, feedbackText, sessionId, customerId, website) {
    const url = `${config.BASE_URL}/track/feedback`;
    const userAgent = navigator.userAgent;

    const body = {
        ft: 'text',
        f_text: feedbackText,
        site: website,
        c_id: customerId,
        url: productLink,
        ua: userAgent,
        se_id: sessionId
    }

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    return response;
}